import { TextInput } from '@kcftech/design-system';
import { IntegrationsFormData } from 'pages/Settings/Integrations/CreateIntegrationModal';
import {
    IntegrationAuthMaxChar,
    IntegrationMaxChar,
} from 'pages/Settings/Integrations/shared';
import { AuthenticationType } from 'pages/Settings/Integrations/types';
import { UseFormReturn } from 'react-hook-form';

export type AuthFieldsProps = Readonly<{
    form: UseFormReturn<IntegrationsFormData>;
    type: AuthenticationType;
}>;

export function AuthFields({
    form: {
        register,
        watch,
        formState: { errors },
    },
    type,
}: AuthFieldsProps) {
    const selectedIntegrationType = watch('IntegrationType');
    const isBasic = type === AuthenticationType.Basic;
    const idText = isBasic ? 'User ID' : 'Client ID';
    const secretText = isBasic ? 'Password' : 'Secret';

    return (
        <>
            {type !== AuthenticationType.ApiKey && (
                <TextInput
                    label={idText}
                    placeholder={`Please enter a ${selectedIntegrationType.toUpperCase()} ${idText}`}
                    error={errors.id?.message}
                    {...register('id', {
                        maxLength: {
                            value: IntegrationAuthMaxChar,
                            message: `${idText} must be less than ${IntegrationAuthMaxChar} characters`,
                        },
                    })}
                />
            )}
            <TextInput
                label={secretText}
                placeholder={`Please enter a ${selectedIntegrationType.toUpperCase()} ${secretText}`}
                type="password"
                error={errors.secret?.message}
                {...register('secret', {
                    maxLength: {
                        value: IntegrationAuthMaxChar,
                        message: `${secretText} must be less than ${IntegrationAuthMaxChar} characters`,
                    },
                })}
            />
            {type === AuthenticationType.OAuth && (
                <TextInput
                    label="Token URL"
                    placeholder="Enter Token URL"
                    error={errors.tokenurl?.message}
                    {...register('tokenurl', {
                        maxLength: {
                            value: IntegrationMaxChar,
                            message: `Token URL must be less than ${IntegrationMaxChar} characters`,
                        },
                    })}
                />
            )}
        </>
    );
}
